import { reverse } from 'named-urls';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SECTION_NAMES } from '@constants/sectionNames';
import { EmptyState, List, Table, useMediaQueryContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { AnalyticsReportsListItem } from '../AnalyticsReportsListItem/AnalyticsReportsListItem';
import { ReportDownloadButton } from '../ReportDownloadButton/ReportDownloadButton';
import { ReportName } from '../ReportName/ReportName';
import * as S from './AnalyticsReportsData.styled';
const getRowLink = (report) => ({
    pathname: reverse(routing.analyticsV2.reports.report.self, {
        reportId: report.id,
    }),
    search: location.search,
});
export const AnalyticsReportsData = ({ data, isLoading, onDownload, }) => {
    const media = useMediaQueryContext();
    const location = useLocation();
    const locationState = {
        from: { label: SECTION_NAMES.analyticsReports, location },
    };
    const emptyComponent = (React.createElement(EmptyState, { title: "There are no reports available", variant: media.tablet ? 'primary' : 'secondary' }));
    if (!data.length)
        return (React.createElement(S.EmptyStateContainer, null,
            React.createElement(EmptyState, { title: "There are no reports available", variant: media.tablet ? 'primary' : 'secondary' })));
    if (!media.tablet) {
        return (React.createElement(List, { data: data, isLoading: isLoading, emptyComponent: emptyComponent, renderItem: (item) => (React.createElement(AnalyticsReportsListItem, { item: item, onDownload: () => onDownload(item.id) })), locationState: locationState, getItemLink: getRowLink }));
    }
    // TODO: Handle location state in table
    return (React.createElement(Table, { headers: [
            {
                id: 'name',
                label: 'Report',
                render: ({ name, externalSource }) => (React.createElement(ReportName, { name: name, externalSource: externalSource })),
            },
            {
                id: 'download',
                label: 'CSV download',
                render: ({ id, downloadEnabled = true }) => downloadEnabled ? React.createElement(ReportDownloadButton, { onDownload: () => onDownload(id) }) : null,
                alignment: 'right',
            },
        ], data: data, emptyComponent: emptyComponent, isLoading: isLoading, rowComponent: Link, getRowLink: getRowLink }));
};
